import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Table from "@bmi-digital/components/table";

export const DesktopTableWrapper = styled("div")(({ theme }) => ({
  display: "none",

  "&>div>table": {
    border: 0,

    "&>thead>tr": {
      border: "0 !important"
    }
  },

  "&>div": {
    border: `1px solid ${theme.colours.storm}`,
    overflow: "hidden",

    "&:first-of-type": {
      borderTopRightRadius: "3px",
      borderTopLeftRadius: "3px"
    },

    "&:last-of-type": {
      borderBottomRightRadius: "3px",
      borderBottomLeftRadius: "3px"
    },

    "&:not(:last-of-type)": {
      borderBottom: 0
    }
  },

  [theme.breakpoints.up("lg")]: {
    display: "block"
  }
}));

export const FeatureValue = styled(Typography)({
  marginBottom: "6px",
  zIndex: 2,
  wordBreak: "break-word",
  position: "relative",
  "&:last-of-type": {
    marginBottom: 0
  }
});

export const StyledTableCell = styled(Table.Cell)(({ theme }) => ({
  wordBreak: "break-word",
  lineHeight: "1.2rem",
  textAlign: "left",

  "&&": {
    padding: "12px 16px",
    color: theme.colours.slate,
    lineHeight: "1.4rem",

    "&:is(td):last-of-type": {
      color: theme.colours.charcoal
    },

    "&:is(th)": {
      lineHeight: "1.2rem",
      padding: "17px 16px",
      fontFamily: "Effra Bold",
      color: theme.colours.charcoal
    }
  },

  "&:first-of-type": {
    width: "250px",

    [theme.breakpoints.up(1025)]: {
      width: "300px"
    }
  }
}));

export const MobileTable = styled("div")(({ theme }) => ({
  display: "none",

  [theme.breakpoints.down("lg")]: {
    display: "block"
  }
}));

export const MobileTableRow = styled("div")(({ theme }) => ({
  display: "flex",
  border: `1px solid ${theme.colours.storm}`,

  "&:not(:last-of-type)": {
    borderBottom: 0
  },

  "&:first-of-type": {
    borderTopRightRadius: "3px",
    borderTopLeftRadius: "3px"
  },

  "&:last-of-type": {
    borderBottomRightRadius: "3px",
    borderBottomLeftRadius: "3px"
  },

  "&:first-of-type>div::before": {
    borderTop: `1px solid ${theme.colours.storm}`
  },

  [theme.breakpoints.down(721)]: {
    flexDirection: "column",
    border: 0
  }
}));

export const MobileTableRowHeader = styled("div")(({ theme }) => ({
  width: "250px",
  fontWeight: "bold",
  fontFamily: "Effra Bold",
  padding: "16px",
  background: theme.colours.pearl,
  borderRight: `1px solid ${theme.colours.storm}`,
  lineHeight: "1.2",

  "&>span": {
    zIndex: 2,
    display: "block",
    position: "relative"
  },

  [theme.breakpoints.down(721)]: {
    width: "100%",
    borderRight: 0,
    padding: "16px 0",
    position: "relative",

    "&::before": {
      borderBottom: `1px solid ${theme.colours.storm}`,
      zIndex: 1,
      content: "''",
      display: "block",
      position: "absolute",
      background: theme.colours.pearl,
      inset: "0 -24px",

      [theme.breakpoints.down("sm")]: {
        inset: "0 -16px"
      }
    }
  }
}));

export const MobileTableFeatureGroup = styled("div")(({ theme }) => ({
  width: "calc(100% - 250px)",

  [theme.breakpoints.down(721)]: {
    width: "100%"
  }
}));

export const MobileTableFeatureRow = styled("div")(({ theme }) => ({
  borderBottom: `1px solid ${theme.colours.storm}`,
  width: "100%",
  padding: "12px 0",

  "&>*": {
    padding: "0 16px",

    [theme.breakpoints.down(721)]: {
      padding: "0"
    }
  },

  "&:last-of-type": {
    borderBottom: 0
  },

  [theme.breakpoints.down(721)]: {
    borderBottom: 0,
    position: "relative",
    zIndex: 1,

    "&>span": {
      zIndex: 2
    },

    "&::before": {
      borderBottom: `1px solid ${theme.colours.storm}`,
      zIndex: 1,
      content: "''",
      display: "block",
      position: "absolute",
      background: theme.colours.white,
      inset: "0 -24px",

      [theme.breakpoints.down("sm")]: {
        inset: "0 -16px"
      }
    }
  }
}));

export const MobileTableFeatureName = styled(Typography)(({ theme }) => ({
  display: "block",
  wordBreak: "break-word",
  color: theme.colours.slate,
  marginBottom: "6px",
  zIndex: 2,
  position: "relative"
}));
